import React, { useEffect, useState } from "react";
import {
    Button,
    Stack,
    Typography,
    Paper,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    SwipeableDrawer,
    Box
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";

import Loading from "../common/loading";
import { t } from "i18next";
import { getLocalStorageMenuItem, setLocalStorageMenuItem, setMobileBackColor, setMobileCardBorderColor, setMobileSubTextColor, setMobileTextColor } from "../utility";

export default function DeliveryDrawer({ open, openLocationFormDailog, openDeleteLocationDialog, onClose, onSelect, onSelectPlace, isLoadingSavedPlaces, savedPlaces }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedPlace, setSelectedPlace] = useState(null);

    useEffect(() => {
        setLocalStorageMenuItem("pendingDelivery", "false");
    }, []);

    const handleMenuClick = (event, place) => {
        setAnchorEl(event.currentTarget);
        setSelectedPlace(place);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedPlace(null);
    };

    const handleEdit = () => {
        onSelectPlace(selectedPlace, true);
        openLocationFormDailog();
        handleMenuClose();
    };

    const handleDelete = () => {
        onSelectPlace(selectedPlace, true);
        openDeleteLocationDialog(selectedPlace);
        handleMenuClose();
    };

    const handleCardClick = (place) => {
        onSelectPlace(place, false);
    };

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            onOpen={() => { }}
            className="alignByLang"
            sx={{
                "& .MuiDrawer-paper": {
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    backgroundColor: setMobileBackColor(),
                    color: setMobileTextColor(),
                    maxHeight: "80vh"
                }
            }}
        >
            <Box sx={{ p: 2 }} className="alignByLang">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography className="head-font" variant="h6">
                        {t("Select Delivery Location")}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>



                {isLoadingSavedPlaces ? (
                    <Loading />
                ) : (
                    savedPlaces?.length > 0 && (
                        <>
                            <Divider sx={{ my: 3 }} />
                            <Typography className="head-font" variant="subtitle1" gutterBottom>
                                💾 {t("Saved Locations")}
                            </Typography>
                            <Stack spacing={2} sx={{ overflowY: "auto", maxHeight: "50vh", pb: 2 }}>
                                {savedPlaces?.map((place) => (
                                    <Paper
                                        key={place.id}
                                        elevation={3}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: setMobileBackColor(),
                                            color: setMobileTextColor(),
                                            border: `1px solid ${setMobileCardBorderColor()}`,
                                            cursor: "pointer",
                                            position: "relative",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
                                            },
                                        }}
                                        onClick={() => handleCardClick(place)}
                                    >
                                        <Stack direction="column" spacing={1}>
                                            <Typography className="head-font" variant="h6" fontWeight="bold">
                                                {place.title}
                                            </Typography>
                                            <Typography className="sub-font" variant="body2" >
                                                {t("Street")} {place.street}, {t("Unit No")} {place.unit_number}, {t("Floor No")} {place.floor_number}, {t("Apartment No")} {place.apartment_number}
                                            </Typography>
                                            <Typography className="sub-font" variant="caption" >
                                                {place.description}
                                            </Typography>
                                            {/* <Stack className="sub-font" direction="row" spacing={2} mt={1}>
                                                <Typography className="sub-font" variant="caption" >
                                                    {t("Coordinates")} : ({place.longitude}, {place.latitude})
                                                </Typography>
                                            </Stack> */}
                                        </Stack>
                                        <IconButton
                                            sx={{
                                                position: "absolute",
                                                backgroundColor: "transparent",
                                                color: setMobileTextColor(),
                                                top: 8,
                                                right: getLocalStorageMenuItem("lang") === "ar" ||
                                                    getLocalStorageMenuItem("lang") === "fa" ? null : 8,

                                                left: getLocalStorageMenuItem("lang") === "ar" ||
                                                    getLocalStorageMenuItem("lang") === "fa" ? 8 : null,
                                                "&:hover": {
                                                    backgroundColor: setMobileBackColor(),
                                                    color: setMobileTextColor(),
                                                },
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleMenuClick(e, place);
                                            }}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                    </Paper>
                                ))}
                            </Stack>
                            <Menu
                                sx={{
                                    "& .MuiMenu-paper": {
                                        backgroundColor: setMobileBackColor(),
                                        color: setMobileTextColor(),
                                        border: `1px solid ${setMobileCardBorderColor()}`,
                                        borderRadius: 2,
                                    },
                                }}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                transformOrigin={{
                                    vertical: "top", horizontal: "left"
                                }}
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                <MenuItem className="head-font" onClick={handleEdit}>{t("Edit")}</MenuItem>
                                <MenuItem className="head-font" onClick={handleDelete}>{t("Delete")}</MenuItem>
                            </Menu>
                        </>
                    )
                )}

                <Stack spacing={2} mt={2} mb={2}>
                    <Button size="large" sx={{ py: 1.5 }} className="head-font" variant="contained" onClick={() => onSelect("new")}>
                        {t("Select New Location")}
                    </Button>
                </Stack>
            </Box>
        </SwipeableDrawer>
    );
}
